import { IArtist } from '@/types'
import { artworkCardPopulation, getArtworks } from 'api/artworks'
import classNames from 'classnames'
import { ArtworkCard } from 'components/artwork/ArtworkCard'
import { Carousel } from 'components/carousels/Carousel'
import qs from 'qs'
import React from 'react'
import { useQuery } from 'react-query'
import { PropsWithClassName } from 'types'
import { mapIArtworksToArtworkCards } from 'utils/data'

interface MoreFromArtistCarouselProps extends PropsWithClassName {
  artist: IArtist | null
}

export const MoreFromArtistCarousel = ({
  artist,
  className,
}: MoreFromArtistCarouselProps) => {
  const { data: moreArtworks } = useQuery(
    ['more-artworks', artist?.id],
    async () => {
      const query = qs.stringify({
        filters: {
          artists: {
            id: {
              $eq: artist?.id,
            },
          },
        },
        ...artworkCardPopulation,
        pagination: {
          page: 1,
          pageSize: 15,
        },
      })

      const artworks = await getArtworks(query)

      if (!artworks || !artworks.data?.length) return []

      return mapIArtworksToArtworkCards(artworks.data)
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    }
  )

  return (
    <>
      {artist?.id && moreArtworks && moreArtworks.length > 0 && (
        <Carousel
          title='More from artist'
          className={classNames('py-12', className)}
        >
          {moreArtworks.map((artwork, index) => (
            <ArtworkCard key={index} {...artwork} />
          ))}
        </Carousel>
      )}
    </>
  )
}
